var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"success-chip",class:_vm.bem('success-chip', { fullWidth: _vm.fullWidth })},[_c('SvgIcon',{staticClass:"success-chip__icon",attrs:{"icon":"check","color":"muted","size":24}}),_c('b',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }